import React, { useEffect, useState } from "react";
import styles from "./Carousel.module.css";
import review1 from "./reviews/review1.mp4";
import { Link, useLocation, useNavigate } from "react-router-dom";
import sunflower from "./imgs/sunflower.png";
import turtle from "./imgs/turtle.png";
import rose from "./imgs/rose.png";
import p1 from "./imgs/pic1.jpeg";
import p2 from "./imgs/pic2.jpeg";
import p3 from "./imgs/pic3.jpeg";

function Carousel() {
  const [timeLeft, setTimeLeft] = useState({ hours: 23, minutes: 59, seconds: 59 });
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [recentRegistrant, setRecentRegistrant] = useState('');
  const [ctaRegistered, setCtaRegistered] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll("section");

      sections.forEach((sec) => {
        const top = window.scrollY;
        const offset = sec.offsetTop - 400;
        const height = sec.offsetHeight + 1000;

        if (top >= offset && top < offset + height) {
          sec.classList.add("show-animate");
        } else {
          sec.classList.remove("show-animate");
        }
      });
    };

    window.addEventListener("scroll", handleScroll);

    // Countdown timer for workshop registration
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let { hours, minutes, seconds } = prev;
        
        if (seconds > 0) {
          seconds--;
        } else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        }
        
        return { hours, minutes, seconds };
      });
    }, 1000);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      clearInterval(timer);
    };
  }, []);

  useEffect(() => {
    if (location.state?.registrationSuccess) {
      setShowSuccessToast(true);
      setCtaRegistered(true);
      setRecentRegistrant(location.state.registrantName || '');
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location, navigate]);

  useEffect(() => {
    if (!showSuccessToast) return;
    const timer = setTimeout(() => setShowSuccessToast(false), 6000);
    return () => clearTimeout(timer);
  }, [showSuccessToast]);

  useEffect(() => {
    if (!ctaRegistered) return;
    const timer = setTimeout(() => setCtaRegistered(false), 12000);
    return () => clearTimeout(timer);
  }, [ctaRegistered]);

  return (
    <>
      {showSuccessToast && (
        <div className={styles.successToast}>
          <div className={styles.toastContent}>
            <div className={styles.toastTitle}>
              Registration successful
            </div>
            <p className={styles.toastMessage}>
              {recentRegistrant ? `${recentRegistrant}, you're in. We'll send details shortly.` : 'You are all set for the workshop.'}
            </p>
          </div>
          <button
            className={styles.toastClose}
            onClick={() => setShowSuccessToast(false)}
            aria-label="Close success message"
          >
            ✕
          </button>
        </div>
      )}
      {/* Workshop Registration Banner */}
      <div className={styles.workshopNotification}>
        🔥 Discount ends in {timeLeft.hours}h {timeLeft.minutes}m {timeLeft.seconds}s. Hurry Up!
      </div>
      
      <section className={styles.workshopSection}>
        <div className={styles.workshopContainer}>
          <div className={styles.workshopLeft}>
            <div className={styles.workshopPoster}>
              <div className={styles.workshopPosterContent}>
                <div className={styles.posterTitle}>CROCHET<br/>MASTERY<br/>WORKSHOP</div>
                <div className={styles.posterDate}>Starting Tuesday, 24th Jan</div>
                <div className={styles.posterDetails}>
                  📹 LIVE online classes<br/>
                  ⭐ Limited seats
                </div>
                <div className={styles.posterIllustration}>🧶🪡✨</div>
              </div>
            </div>
          </div>
          
          <div className={styles.workshopRight}>
            <h2 className={styles.workshopHeadline}>
              Learn from the founder herself
            </h2>
            <p className={styles.workshopSubtext}>
              Join our <strong>3-Day LIVE workshop</strong> and <em>finish your first crochet project</em> even if you've never held a hook before.
            </p>
            
            <Link 
              to="/workshop-registration" 
              className={`${styles.workshopCTA} ${ctaRegistered ? styles.workshopCTARegistered : ''}`}
            >
              {ctaRegistered ? 'Registered! Add another seat' : 'Join the 3-Day Workshop for ₹99'}
            </Link>
            {ctaRegistered && (
              <div className={styles.registeredNote}>Registered</div>
            )}
            
            <div className={styles.workshopInfo}>
              <div className={styles.infoItem}>
                📅 <strong>Dates:</strong> 24th, 25th & 26th January
              </div>
              <div className={styles.infoItem}>
                🕐 <strong>Time:</strong> 2 PM – 5 PM
              </div>
              <div className={styles.infoItem}>
                🔴 <strong>Only 2 Days Left for Registration.</strong> Hurry Up!
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Products */}
      <div className={styles.sectionTitle}>Featured Products</div>
      <div className={styles.productsGrid}>
        <div className={styles.productCard}>
          <img src={sunflower} alt="Sunflower Stitch" className={styles.productImg} />
          <div className={styles.productInfo}>
            <div className={styles.productTitle}>Sunflower Stitch</div>
            <div className={styles.productDesc}>
              Beautiful hand-embroidered sunflower design.
            </div>
            <Link to="/products" className={styles.productBtn}>Shop Now</Link>
          </div>
        </div>
        <div className={styles.productCard}>
          <img src={turtle} alt="Turtles" className={styles.productImg} />
          <div className={styles.productInfo}>
            <div className={styles.productTitle}>Turtles</div>
            <div className={styles.productDesc}>
              Cute crochet turtle set.
            </div>
            <Link to="/products" className={styles.productBtn}>Shop Now</Link>
          </div>
        </div>
        <div className={styles.productCard}>
          <img src={rose} alt="Roses" className={styles.productImg} />
          <div className={styles.productInfo}>
            <div className={styles.productTitle}>Roses</div>
            <div className={styles.productDesc}>
              Elegant embroidered rose pattern.
            </div>
            <Link to="/products" className={styles.productBtn}>Shop Now</Link>
          </div>
        </div>
      </div>

      {/* Why Choose Us Section */}
      <div className={styles.whySection}>
        <div className={styles.sectionTitle}>Why Rustic Yarns?</div>
        <div className={styles.whyList}>
          <div className={styles.whyItem}>🌸 100% Handmade with love</div>
          <div className={styles.whyItem}>🧶 Premium, eco-friendly yarn</div>
          <div className={styles.whyItem}>🎁 Custom orders &amp; gift packaging</div>
          <div className={styles.whyItem}>👩‍🎨 Workshops for all skill levels</div>
          <div className={styles.whyItem}>🚚 Fast, friendly shipping</div>
        </div>
      </div>

      {/* Testimonials Section */}
      <div className={styles.testimonialsSection}>
        <div className={styles.sectionTitle}>What Our Customers Say</div>
        <div className={styles.testimonialsGrid}>
          <div className={styles.testimonialCard}>
            <img src={p1} alt="Customer" className={styles.testimonialAvatar} />
            <div className={styles.testimonialName}>Aarohi P.</div>
            <div>“The quality and care in every piece is amazing. My blanket is so soft and beautiful!”</div>
          </div>
          <div className={styles.testimonialCard}>
            <img src={p2} alt="Customer" className={styles.testimonialAvatar} />
            <div className={styles.testimonialName}>Riya S.</div>
            <div>“Loved the crochet bag! Super stylish and everyone asks where I got it.”</div>
          </div>
          <div className={styles.testimonialCard}>
            <img src={p3} alt="Customer" className={styles.testimonialAvatar} />
            <div className={styles.testimonialName}>Meera D.</div>
            <div>“Fast shipping and such a sweet handwritten note in my package. Will order again!”</div>
          </div>
        </div>
      </div>

      {/* Experiences/Video Section */}
      <div className={styles.sectionTitle}>See Our Community</div>
      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '3rem' }}>
        <video width="370" height="360" controls style={{ borderRadius: '2rem', boxShadow: '0 4px 16px 0 #e6b8a222' }}>
          <source src={review1} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </>
  );
}
export default Carousel;
